import React from 'react'
import ScrollTopOnMount from 'utils/ScrollTopOnMount'
import ReactHtmlParser from 'react-html-parser';
import Config from 'Config'
import axios from 'axios'

class Privacy extends React.Component {

   constructor() {
      super()
      this.state = {
         data: {},
      }
   }

   componentDidMount() {
      this.getData();
   }

   getData() {

      axios.get(Config().endpoints.api + "/privacy")
         .then(response => {
            if (response.data) {
               this.setState({
                  data: response.data[0]
               });
            }
         })
         .catch((error) => {})
   }

   render() {
      return (<div>
         <ScrollTopOnMount/>
         <div className="content-container">
            <div className="content-section">
               <h1 className="section-bottom">{this.state.data.title}</h1>
               <div>{ ReactHtmlParser(this.state.data.content) }</div>
            </div>
         </div>
      </div>);
   }
}

export default Privacy



// WEBPACK FOOTER //
// ./src/components/Privacy/index.js